import { SxProps, Theme } from '@mui/material/styles';

export const catalogEntryListFacetChipsSX: SxProps<Theme> = {
	'.MuiButtonBase-root': {
		height: '32px',
	},
};

export const facetChipsSX = {
	stackContainer: { width: '100%', minWidth: 0, overflow: 'hidden' },
	filterTitle: { display: { xs: 'none', md: 'block' }, flexShrink: 0, whiteSpace: 'nowrap' },
	chipsContainer: {
		flex: 1,
		flexWrap: 'nowrap',
		whiteSpace: 'nowrap',
		overflowX: 'auto',
		overflowY: 'hidden',
	},
	chips: {
		boxShadow: 'none',
		background: 'white',
		borderRadius: 0,
		border: '1px solid',
		borderColor: 'grey.100',
		fontSize: '14px',
		'&:hover': {
			background: 'white',
		},
	},
	btnClear: {
		color: 'secondary.main',
		flexShrink: 0,
		whiteSpace: 'nowrap',
		'&:hover': { textDecoration: 'underline', color: 'secondary.dark' },
	},
} satisfies Record<string, SxProps<Theme>>;
